(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["commerce-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.crReady) return;
      root.dataset.crReady = '1';
      var cards = Array.prototype.slice.call(root.querySelectorAll('.cr-card'));
      var step = parseInt(root.dataset.step, 10) || 6;
      var more = root.querySelector('.cr-more');
      var chips = Array.prototype.slice.call(root.querySelectorAll('.cr-chip'));
      var topic = 'all';
      var shown = step;
      function render() {
        var match = cards.filter(function (c) { return topic === 'all' || c.dataset.topic === topic; });
        cards.forEach(function (c) { c.hidden = true; });
        match.slice(0, shown).forEach(function (c) { c.hidden = false; });
        if (more) more.hidden = match.length <= shown;
      }
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          topic = chip.dataset.topic;
          shown = step;
          chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
          render();
        });
      });
      if (more) more.addEventListener('click', function () { shown += step; render(); });
      render();
    }
    function initAll() { document.querySelectorAll('[data-commerce-reviews]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-listicle-reason"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const videos = () => document.querySelectorAll('video[data-motion-autoplay="true"]');

    const handleEntries = (entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting && !reduceMotion.matches) {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          video.pause();
        }
      }
    };

    const init = () => {
      if (!('IntersectionObserver' in window)) {
        if (!reduceMotion.matches) {
          for (const v of videos()) {
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          }
        }
        return;
      }
      const io = new IntersectionObserver(handleEntries, { rootMargin: '200px 0px', threshold: 0.01 });
      for (const v of videos()) io.observe(v);
    };

    const onMotionChange = () => {
      if (reduceMotion.matches) {
        for (const v of videos()) { v.pause(); v.currentTime = 0; }
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', onMotionChange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ey-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFAQ(sectionEl) {
    var cards = sectionEl.querySelectorAll('[data-faq-card]');

    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-faq-trigger]');
      var answer  = card.querySelector('[data-faq-answer]');

      if (!trigger || !answer) return;

      trigger.addEventListener('click', function () {
        var isOpen = card.classList.contains('ey-faq-card--open');

        if (isOpen) {
          // Collapse
          card.classList.remove('ey-faq-card--open');
          trigger.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
        } else {
          // Expand
          card.classList.add('ey-faq-card--open');
          trigger.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function getSectionEl(sectionId) {
    return document.getElementById('ey-faq-' + sectionId);
  }

  // Theme editor events
  document.addEventListener('shopify:section:load', function (event) {
    var el = getSectionEl(event.detail.sectionId);
    if (el) initFAQ(el);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block) return;
    var card = block.closest('[data-faq-card]');
    if (!card) return;
    var trigger = card.querySelector('[data-faq-trigger]');
    var answer  = card.querySelector('[data-faq-answer]');
    if (!card.classList.contains('ey-faq-card--open')) {
      card.classList.add('ey-faq-card--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (answer)  answer.setAttribute('aria-hidden', 'false');
    }
  });

  // Init all FAQ sections already on the page
  document.querySelectorAll('[id^="ey-faq-"]').forEach(function (el) {
    initFAQ(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ey-product-highlights"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initHighlights(sectionId) {
    var container = document.getElementById('ey-highlights-' + sectionId);
    if (!container) return;

    var items = container.querySelectorAll('.ey-highlights__item');
    var triggers = container.querySelectorAll('.ey-highlights__trigger');

    function openItem(item) {
      item.classList.add('ey-highlights__item--open');
      var trigger = item.querySelector('.ey-highlights__trigger');
      var panel = item.querySelector('.ey-highlights__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel) {
        // Force a reflow so the transition fires correctly
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }

    function closeItem(item) {
      item.classList.remove('ey-highlights__item--open');
      var trigger = item.querySelector('.ey-highlights__trigger');
      var panel = item.querySelector('.ey-highlights__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) {
        // Animate to 0 then let CSS take over (max-height: 0)
        panel.style.maxHeight = '0';
        // After transition ends, clear inline style so CSS class controls it
        panel.addEventListener('transitionend', function onEnd() {
          panel.removeEventListener('transitionend', onEnd);
          if (!item.classList.contains('ey-highlights__item--open')) {
            panel.style.maxHeight = '';
          }
        });
      }
    }

    function toggleItem(targetItem) {
      var isOpen = targetItem.classList.contains('ey-highlights__item--open');

      // Close all other items (one-at-a-time accordion)
      items.forEach(function (item) {
        if (item !== targetItem && item.classList.contains('ey-highlights__item--open')) {
          closeItem(item);
        }
      });

      // Toggle the clicked item
      if (isOpen) {
        closeItem(targetItem);
      } else {
        openItem(targetItem);
      }
    }

    // Attach click handlers to triggers
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.ey-highlights__item');
        if (item) toggleItem(item);
      });
    });

    // Keyboard: Enter / Space already fire click on <button>, so no extra handling needed.
    // Ensure initially-open items have correct inline maxHeight so transitions work.
    items.forEach(function (item) {
      var panel = item.querySelector('.ey-highlights__panel');
      if (!panel) return;

      if (item.classList.contains('ey-highlights__item--open')) {
        // Set explicit maxHeight so CSS transition can work from this value
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0';
      }
    });
  }

  // Init on DOMContentLoaded (standard page load)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[id^="ey-highlights-"]').forEach(function (el) {
        var sid = el.id.replace('ey-highlights-', '');
        initHighlights(sid);
      });
    });
  } else {
    // DOM is already ready (deferred script or Shopify section rendering)
    document.querySelectorAll('[id^="ey-highlights-"]').forEach(function (el) {
      var sid = el.id.replace('ey-highlights-', '');
      initHighlights(sid);
    });
  }

  // Re-init when Shopify injects a new section instance (theme editor)
  document.addEventListener('shopify:section:load', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (sectionId) {
      initHighlights(sectionId);
    }
  });

  // Handle block select in theme editor — open the relevant item
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block) return;
    var item = block.closest('.ey-highlights__item');
    if (!item) return;
    var container = block.closest('[id^="ey-highlights-"]');
    if (!container) return;
    var sectionId = container.id.replace('ey-highlights-', '');
    // Close all, then open the selected block's item
    var allItems = container.querySelectorAll('.ey-highlights__item');
    allItems.forEach(function (i) { closeItem(i); });
    openItem(item);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
